<template lang="jade">
div.Form__group(":tooltip.sync"="fdata.tip")
  h2.Form__heading(v-if="fdata.label") {{ fdata.label }}
  div.Check-group
    div.Check-group__item(v-for="opt in fdata.options")
      div.Check
        div.Check__label(v-if="opt.label") {{ opt.label }}
        label.Check__control
          input.Check__field(":name"="fdata.field"
                              type="checkbox"
                              ":value"="opt.value"
                              ":checked"="opt.checked"
                              ":disabled"="!fdata.editable"
                              @change="update($event, $index)")
          div.Check__indicator
        div.Check__label(v-if="fdata.suffix"
                            class="Check__append") {{ opt.suffix }}
</template>
<script>
  import _ from 'lodash'
  import inputs from '../_shared/traits'

  export default {
    mixins: [inputs],
    data () {
      return {
        formInput: [],
        unchecked: '',
        show: false
      }
    },
    props: {
      fdata: {
        type: Object,
        coerce (val) {
          if (val.editable === false) {
            val.field = false
          }
          return _.set(val, 'options', val.options.map(n => {
            return _.set(n, 'checked', _.includes(n.checked, n.code))
          }))
        }
      }
    },
    methods: {
      toggle () {
        this.show = !this.show
      },
      update (e, idx) {
        this.fdata.options[idx].checked = e.target.checked
        let input = this.fdata.options.filter(xs => xs.checked === true)
                                      .map(xs => xs.value)
        this.$set('formInput', input)
        this.validate()
      }
    },
    ready () {
      this.$set('formInput', this.fdata.value)
    }
  }
</script>



// WEBPACK FOOTER //
// group.vue?4bcdfcf1